module.exports = __webpack_public_path__ + "static/media/JinRong5.2328cb79.png";